import { get2, put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { IDeliveryMethod } from "@/shared/utils/interfaces";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const useDeliveryMethodsHook = () => {
  const branch = useBranchId();

  const deliveryMethodsQuery = useQuery<IDeliveryMethod[]>({
    queryKey: ["deliveryMethod", branch],
    queryFn: () => get2(`/internal/secure/pos/v1/delivery/methods/${branch}`),
    enabled: branch !== undefined,
  });

  const inuseDeliveryMethodsQuery = useQuery<IDeliveryMethod[]>({
    queryKey: ["inuseDeliveryMethods", branch],
    queryFn: () =>
      get2(`internal/secure/pos/v1/delivery/inuse/methods/${branch}`),
    enabled: branch !== undefined,
    select: (data) => (Array.isArray(data) ? data : []),
    refetchOnWindowFocus: false,
  });

  const updateDeliveryMethods = useMutation({
    mutationFn: (data: any) => {
      return put2(`internal/secure/pos/v1/delivery/methods/${branch}`, data);
    },
    onSuccess: () => {
      toast.success("Extra verwijdert", {
        position: "bottom-right",
        toastId: "updateDeliveryMethods",
      });
      inuseDeliveryMethodsQuery.refetch();
      deliveryMethodsQuery.refetch();
    },
  });

  return {
    deliveryMethodsQuery,
    inuseDeliveryMethodsQuery,
    updateDeliveryMethods,
  };
};

export default useDeliveryMethodsHook;
